
import { ReactComponent as ArrowRight } from '../../Assets/angle-right-solid.svg';
import { ReactComponent as MagnifyingGlass } from '../../Assets/magnifying-glass-solid.svg';
import { useHelpCenterStore } from '../../Stores/HelpCenter';
import { useRouterStore } from '../../Stores/Router';
import { activateOnKey } from '../../Helper/a11y';
import './HelpCenterSearch.scss';

interface HelpCenterSearchAttributes {
    articles: any[];
    label: string;
}

const HelpCenterSearch = ({
    articles = [],
    label
}: HelpCenterSearchAttributes) => {
    return (
        <div className="search-card">
            <div className="search-card-topbar" role="button" tabIndex={0} aria-label={label} onClick={() => {
                useRouterStore.getState().setPage("helpcenter");
            }} onKeyDown={activateOnKey(() => {
                useRouterStore.getState().setPage("helpcenter");
            })}>
                <div className="search-card-topbar-title">{label}</div>
                <MagnifyingGlass className='search-card-topbar-icon' />
            </div>
            {articles && articles.length > 0 && (
                <div className="search-card-list">
                    {articles.map((article) => {
                        return (
                            <div className="search-card-list-item" key={article.id} role="button" tabIndex={0} onClick={() => {
                                useHelpCenterStore.getState().openArticle(article.id);
                            }} onKeyDown={activateOnKey(() => {
                                useHelpCenterStore.getState().openArticle(article.id);
                            })}>
                                <div className='search-card-list-item-title'>{article.title}</div>
                                <ArrowRight />
                            </div>
                        );
                    })}
                </div>)}
        </div>
    );
};

export default HelpCenterSearch;